// extracted by mini-css-extract-plugin
export default {"departments":"UF-z","departmentHeading":"VF-z","departmentSection":"WF-z","departmentName":"XF-z","departmentLink":"YF-z","expandIcon":"ZF-z"};